import { Price } from "@/models/Price"
import { DateTime } from "luxon"
import { toTimestamp } from "@/models/MaybeTimestamp"

export const calculateStartAt = (
  price: Price,
  localTimeOverride?: DateTime,
) => {
  const { startType, cohortDate, startAnchor } = price
  // console.log({ startType, cohortDate, startAnchor, localTimeOverride })

  const now = localTimeOverride ?? DateTime.now()

  // cases - older offerings don't have a startType
  if (!startType || startType === "IMMEDIATE") {
    return null
  }

  if (startType === "ABSOLUTE") {
    // cohortDate is definitely present
    if (!cohortDate) {
      throw new Error("cohortDate is required for ABSOLUTE startType")
    }

    return DateTime.fromSeconds(toTimestamp(cohortDate).seconds)
  }

  if (startType === "RELATIVE") {
    if (startAnchor == null) {
      throw new Error("startAnchor is required for DELAYED startType")
    }

    const { offset, timeZone } = startAnchor

    if (timeZone == null) {
      throw new Error(
        "timeZone is required in startAnchor for DELAYED startType",
      )
    }

    const dateTime = now
      .startOf("day")
      .set({ hour: 9 })
      .setZone(timeZone.identifier)

    const currentDay = dateTime.weekday
    const distance = (offset + 7 - currentDay) % 7
    return dateTime.plus({ days: distance })
  }

  if (startType === "DELAYED") {
    if (!startAnchor) {
      throw new Error("startAnchor is required for DELAYED startType")
    }
    const unit = startAnchor.unit

    let startAnchorDate: DateTime
    if (unit === "day") {
      startAnchorDate = now.plus({ days: startAnchor.offset })
    } else if (unit === "week") {
      startAnchorDate = now.plus({ days: startAnchor.offset * 7 })
    } else if (unit === "month") {
      startAnchorDate = now.plus({ months: startAnchor.offset })
    } else {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Invalid startAnchor unit ${unit}`)
    }

    return startAnchorDate
  }

  return null
}
